import ls from "local-storage";
import { STRING_MAP } from "../i18n/base";

export const STORE_KEY = "IframeRSStore";
const VERSION = "1.0";

export const ID_COOKIE_NAME = "rs_id";
const DOMAIN = "https://d1ih8ekqwu0z3v.cloudfront.net/";
const API_DOMAIN = process.env.REACT_APP_DOMAIN || "api.robosize.com";
export const FULL_API_DOMAIN =
  process.env.REACT_APP_FULL_DOMAIN || `https://${API_DOMAIN}`;

export const params = new Proxy(new URLSearchParams(window.location.search), {
  get: (searchParams, prop) => searchParams.get(prop),
});

const defaultLocalizations = [
  { value: "en", label: "English" },
  { value: "de", label: "Deutsch" },
  { value: "es", label: "Español" },
  { value: "it", label: "Italiano" },
  { value: "pt", label: "Português" },
  { value: "tr", label: "Türkçe" },
  { value: "fa", label: "فارسی" },
];

export const UNIT_METHOD = {
  METRIC: "metric",
  IMPERIAL: "imperial",
};

export const SWITCH_TYPE = {
  LENGTH: "lenght",
  WEIGHT: "weight",
};

export const GENDER = {
  MALE: "male",
  FEMALE: "female",
};

export const LENGTH_UNIT = {
  CM: "cm",
  INCH: "in",
  FT: "ft",
};
export const WEIGHT_UNIT = {
  KG: "kg",
  POUNDS: "lb",
};

export const data = ls.get(STORE_KEY) || {};
data.VERSION = VERSION;
ls.set(STORE_KEY, data);

export const MEASURE = {
  AGE: "age",
  BUST: "bust",
  WAIST: "waist",
  HIP: "hip",
  INSIDE_LEG: "inside_leg",
  NECK: "neck",
  SLEEVE: "sleeve",
  LENGTH: "length",
  HEIGHT: "height",
  WEIGHT: "weight",
};

const INTERVIEW_METHODS = {
  CUP_BODY_FIT: "cup__body__fit",
  SIZE_FIT_ADJUST: "size__fit__adjust",
};

export const RECOMMENDATION_METHOD = {
  MEASURES: "measures",
  TOP_TWO: "top_two",
  SINGLE: "single",
  SOCIAL_PROOF: "social",
};

const baseConfig = {
  appClass: "",
  size: "lg",
  strings: STRING_MAP,
  direction: "ltr",
  sample_selfie: {
    female: [
      {
        index: 1,
        gender: "female",
        faceData: {
          l_eye: [288, 322],
          r_eye: [374, 323],
          nose: [330, 372],
          center: [331, 323],
          radius: 95,
          chin: [329, 474],
        },
        image: "https://api.robosize.com/media/sample_selfie/1.jpg",
      },
      {
        index: 2,
        gender: "female",
        faceData: {
          l_eye: [283, 330],
          r_eye: [376, 332],
          nose: [332, 394],
          center: [325, 324],
          radius: 104,
          chin: [329, 498],
        },
        image: "https://api.robosize.com/media/sample_selfie/2.jpg",
      },
      {
        index: 3,
        gender: "female",
        faceData: {
          l_eye: [273, 389],
          r_eye: [362, 385],
          nose: [321, 444],
          center: [317, 375],
          radius: 100,
          chin: [328, 544],
        },
        image: "https://api.robosize.com/media/sample_selfie/3.jpg",
      },
    ],
    male: [
      {
        index: 4,
        gender: "male",
        faceData: {
          l_eye: [271, 314],
          r_eye: [356, 312],
          nose: [312, 361],
          center: [315, 319],
          radius: 97,
          chin: [315, 466],
        },
        image: "https://api.robosize.com/media/sample_selfie/4.jpg",
      },
      {
        index: 5,
        gender: "male",
        faceData: {
          l_eye: [255, 296],
          r_eye: [354, 293],
          nose: [304, 358],
          center: [306, 295],
          radius: 111,
          chin: [312, 479],
        },
        image: "https://api.robosize.com/media/sample_selfie/5.jpg",
      },
      {
        index: 6,
        gender: "male",
        faceData: {
          l_eye: [244, 279],
          r_eye: [338, 274],
          nose: [291, 329],
          center: [295, 270],
          radius: 106,
          chin: [304, 446],
        },
        image: "https://api.robosize.com/media/sample_selfie/6.jpg",
      },
    ],
  },

  bustShape: {
    female: [
      {
        value: -1,
        label: "BUST_OFFSET_SMALL",
        image: `${DOMAIN}static/assets/media/W-1-1.png`,
      },
      {
        value: 0,
        label: "BUST_OFFSET_AVERAGE",
        image: `${DOMAIN}static/assets/media/W-1-2.png`,
      },
      {
        value: 1,
        label: "BUST_OFFSET_LARGE",
        image: `${DOMAIN}static/assets/media/W-1-3.png`,
      },
    ],
    male: [
      {
        value: -1,
        label: "BUST_OFFSET_SMALL",
        image: `${DOMAIN}static/assets/media/M-1-1.png`,
      },
      {
        value: 0,
        label: "BUST_OFFSET_AVERAGE",
        image: `${DOMAIN}static/assets/media/M-1-2.png`,
      },
      {
        value: 1,
        label: "BUST_OFFSET_LARGE",
        image: `${DOMAIN}static/assets/media/M-1-3.png`,
      },
    ],
  },

  waistShape: {
    female: [
      {
        value: -1,
        label: "WAIST_OFFSET_SMALL",
        image: `${DOMAIN}static/assets/media/W-2-1.png`,
      },
      {
        value: 0,
        label: "WAIST_OFFSET_AVERAGE",
        image: `${DOMAIN}static/assets/media/W-2-2.png`,
      },
      {
        value: 1,
        label: "WAIST_OFFSET_LARGE",
        image: `${DOMAIN}static/assets/media/W-2-3.png`,
      },
    ],
    male: [
      {
        value: -1,
        label: "WAIST_OFFSET_SMALL",
        image: `${DOMAIN}static/assets/media/M-2-1.png`,
      },
      {
        value: 0,
        label: "WAIST_OFFSET_AVERAGE",
        image: `${DOMAIN}static/assets/media/M-2-2.png`,
      },
      {
        value: 1,
        label: "WAIST_OFFSET_LARGE",
        image: `${DOMAIN}static/assets/media/M-2-3.png`,
      },
    ],
  },

  hipShape: {
    female: [
      {
        value: -1,
        label: "HIP_OFFSET_SMALL",
        image: `${DOMAIN}static/assets/media/W-3-1.png`,
      },
      {
        value: 0,
        label: "HIP_OFFSET_AVERAGE",
        image: `${DOMAIN}static/assets/media/W-3-2.png`,
      },
      {
        value: 1,
        label: "HIP_OFFSET_LARGE",
        image: `${DOMAIN}static/assets/media/W-3-3.png`,
      },
    ],
    male: [
      {
        value: -1,
        label: "HIP_OFFSET_SMALL",
        image: `${DOMAIN}static/assets/media/M-3-1.png`,
      },
      {
        value: 0,
        label: "HIP_OFFSET_AVERAGE",
        image: `${DOMAIN}static/assets/media/M-3-2.png`,
      },
      {
        value: 1,
        label: "HIP_OFFSET_LARGE",
        image: `${DOMAIN}static/assets/media/M-3-3.png`,
      },
    ],
  },

  fullShape: {
    female: [
      {
        value: "rectangle",
        label: "FULL_OFFSET_RECTANGLE",
        offsets: {
          bustOffset: 0,
          waistOffset: 0,
          hipOffset: 0,
        },
        image:
          "https://api.robosize.com/static/media/widget/shape/female-rectangle.png",
      },
      {
        value: "circle",
        label: "FULL_OFFSET_CIRCLE",
        offsets: {
          bustOffset: 0,
          waistOffset: 1,
          hipOffset: 1,
        },
        image:
          "https://api.robosize.com/static/media/widget/shape/female-circle.png",
      },
      {
        value: "triangle",
        label: "FULL_OFFSET_TRIANGLE",
        offsets: {
          bustOffset: -1,
          waistOffset: 0,
          hipOffset: 1,
        },
        image:
          "https://api.robosize.com/static/media/widget/shape/female-triangle.png",
      },
      {
        value: "reverse_triangle",
        label: "FULL_OFFSET_REVERSE_TRIANGLE",
        offsets: {
          bustOffset: 1,
          waistOffset: 0,
          hipOffset: -1,
        },
        image:
          "https://api.robosize.com/static/media/widget/shape/female-reverse_triangle.png",
      },
      {
        value: "hour_glass",
        label: "FULL_OFFSET_HOUR_GLASS",
        offsets: {
          bustOffset: 1,
          waistOffset: 0,
          hipOffset: 1,
        },
        image:
          "https://api.robosize.com/static/media/widget/shape/female-hour_glass.png",
      },
    ],
    male: [
      {
        value: "rectangle",
        label: "FULL_OFFSET_RECTANGLE",
        offsets: {
          bustOffset: 0,
          waistOffset: 0,
          hipOffset: 0,
        },
        image:
          "https://api.robosize.com/static/media/widget/shape/male-rectangle.png",
      },
      {
        value: "circle",
        label: "FULL_OFFSET_CIRCLE",
        offsets: {
          bustOffset: 0,
          waistOffset: 1,
          hipOffset: 1,
        },
        image:
          "https://api.robosize.com/static/media/widget/shape/male-circle.png",
      },
      {
        value: "triangle",
        label: "FULL_OFFSET_TRIANGLE",
        offsets: {
          bustOffset: -1,
          waistOffset: 0,
          hipOffset: 1,
        },
        image:
          "https://api.robosize.com/static/media/widget/shape/male-triangle.png",
      },
      {
        value: "reverse_triangle",
        label: "FULL_OFFSET_REVERSE_TRIANGLE",
        offsets: {
          bustOffset: 1,
          waistOffset: 0,
          hipOffset: -1,
        },
        image:
          "https://api.robosize.com/static/media/widget/shape/male-reverse_triangle.png",
      },
    ],
  },

  integrationButton: {
    selector: null,
    chart_selector: null,
    render_chart: null,
    class: "",
    containerClass: "",
    wrapperClass: "",
    showSizeChart: false,
    showAIFitting: true,
  },
  productPageIntegration: {
    enabled: false,
  },
  sizeChart: {
    roundTo: 0.25,
  },
  sizeChangeIntegration: {
    enabled: true,
    filterSizeOptions: false,
    appId: "if_integration_images_app",
    imageAppContainerSelector: null,
    getSizeChangeListener: null,
    mapSizeOptionValue: null,
    hideUnavailabelSizes: null,
  },
  interview: {
    showTutorial: false,
    interviewMethod: INTERVIEW_METHODS.SIZE_FIT_ADJUST,
    forceGender: null,
    skipBraSize: false,
    askBodyShapes: false,
    askBodyShapeAdjustments: false,
    askKnownBrand: false,
    askTShirt: false,
    askFitPreference: false,
    manualMeasurement: false,
    basicQuestions: {
      ageInput: "select",
      defaultUnit: null,
      hideAge: false,
      ageOptional: false,
      askNeck: false,
      neckOptional: true,
      askLength: false,
      lengthOptional: true,
      showSizeChartButton: false
    },
    bodyShape: {
      hideHip: false,
      askLength: false,
      lengthOptional: true,
    },
    bodyForm: {
      images: {},
    },
    recommendation: {
      method: RECOMMENDATION_METHOD.MEASURES,
      recommendSizeOnly: false,
      recommendProducts: false,
    },
    measure_range: {
      [MEASURE.AGE]: [1, 99],
      [MEASURE.BUST]: [70, 150],
      [MEASURE.WAIST]: [50, 150],
      [MEASURE.HIP]: [70, 150],
      [MEASURE.INSIDE_LEG]: [60, 100],
      [MEASURE.NECK]: [30, 50],
      [MEASURE.SLEEVE]: [50, 80],
      [MEASURE.LENGTH]: [50, 100],
      [MEASURE.WEIGHT]: [20, 150],
      [MEASURE.HEIGHT]: [50, 300],
    },
  },
};

export const dataInit = {
  activeStep: 0,
  lang: -1,
  activeProfile: 1,
  modalStatus: "hide",
  faceApiLoaded: false,
  profiles: {
    one: {
      id: 1,
      info: {},
      data: {
        bodyMeasurement: {},
        gender: null,
        unit: null,
        height: null,
        weight: null,
        age: "",
        bodyType: "",
        bustOffset: "",
        waistOffset: "",
        hipOffset: "",
        band: "",
        cup: "",
        neck: "",
        length: "",
        fitPreference: 0,
        tryOn: "",
        file: "",
        face: "",
        fileUpload: "",
        faceUpload: "",
        useFile: false,
        typical_size: null,
        useSampleImage: false,
      },
    },
  },
};

export const configInit = {
  product: {
    id: "",
    business: {
      id: "1833ab6953",
      store_type: "shopify",
      domain: params.domain,
      config: { ...baseConfig },
    },
    has_virtual_model: true,
    gender: "all", // all , male , female, kid, baby
  },
  steps: [],
  localizations: defaultLocalizations,
  version: 1,
  rs_id: params.rs_id,
  store_id: params.store_id,
  siteLanguage: params.lang,
};

export const sessionShare = {
  cameraEnabled: false,
};
